import {ManifestStop, NestedJobStop, Stop} from "../../generated/graphql";
import {isCompleted} from "./StopUtils";

function getStopTimeByStopType(stop: NestedJobStop | ManifestStop | Stop, stopType: string | null | undefined) {
  let stopTime;
  if (isCompleted(stop)) {
    stopTime = getStopCompletedTime(stop);
  } else if (stop.earlyDateTime && (stopType === "P" || stopType === "B")) {
    stopTime = stop.earlyDateTime;
  } else {
    stopTime = stop.scheduledDateTime;
  }
  return stopTime ?? undefined;
}

export const getStopCompletedTime = (stop: NestedJobStop | ManifestStop | Stop) => {
  if (isCompleted(stop)) {
    return stop.podDateTime ?? stop.departDateTime ?? stop.arriveDateTime;
  }
  return undefined;
};

function getStopPreposition(stop: Stop | NestedJobStop | ManifestStop): string | null {
  return getStopPrepositionForType(stop, stop.stopType);
}

function getStopPrepositionForType(
  stop: Stop | NestedJobStop | ManifestStop,
  stopType: string | undefined | null
): string | null {
  if (isCompleted(stop)) {
    return null;
  }

  switch (stopType) {
    case "D":
      return "by";
    case "P":
    case "B":
      return "at";
  }

  return null;
}

export {getStopTimeByStopType, getStopPreposition, getStopPrepositionForType};
